<ng-container *ngIf="{
  list: (list$ | async),
  showAddAction: (showAddAction$ | async)
} as streams$">
  <int-labeled-field-box
    [isActive]="isActive"
    [isFocus]="isOpen"
    [isError]="isError"
    [label]="outputLabel"
    [isLabelBox]="false"
    (onContentTap)="onClickHandler(field)"
  >
    <ng-container ngProjectAs="center-position">
      <ng-container>
        <div class="ip-c" #container>
          <div class="ip-c__tags-container">
            <ul class="ip-c__tags-list">
              <li class="ip-c__tag-item" *ngFor="let record of streams$.list">
                <int-closed-tag (onClose)="delete(record)">
                  {{ record }}
                </int-closed-tag>
                <int-empty-divider size="0.2rem"></int-empty-divider>
              </li>
              <div class="ip-c__input-wrap">
                <div class="sizer" [style.max-width.px]="container.getBoundingClientRect().width">{{currentValue}}</div>
                <input
                  #field
                  (focus)="setFocus(true)"
                  (blur)="setFocus(false)"
                  (input)="setValue($event)"
                  [value]="currentValue"
                  [disabled]="disabled"
                  class="ip-c__field" type="text">
              </div>
            </ul>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container ngProjectAs="right-position">
      <div class="actions-container">
        <ng-content select="right-position"></ng-content>
        <button class="add-action" *ngIf="streams$.showAddAction" (click)="add()">
          <int-icon name="plus-circle" size="1.5rem"></int-icon>
        </button>
      </div>
    </ng-container>
  </int-labeled-field-box>
</ng-container>

